import axiosInstance from "./AxiosInstance"

// Fetch menopause chart list
export function getPatientMenopauseChart(patient_id) {
  return axiosInstance.post("/patient/menopauseList", {
    patient_id,
  
  })
}

// Create new record
export function createPatientMenopauseChart(data) {
  return axiosInstance.post("/patient/addMenopause", data)
}

// Update existing record
export function updatePatientMenopauseChart(data) {
  return axiosInstance.post("/patient/editMenopause", data)
}

// Delete a record
export function deletePatientMenopauseChart(entry) {
  return axiosInstance.post("/patient/deleteMenopause", entry)
}

// Format fetched data
export function formatPatientMenopauseChart(responseData) {
  if (!responseData) return []

  if (Array.isArray(responseData)) {
    return responseData.map((entry) => formatEntry(entry))
  }

  const formatted = []
  for (const key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      const entry = responseData[key]
      formatted.push(formatEntry(entry, key))
    }
  }

  return formatted
}

// Format each entry
function formatEntry(entry, key = null) {
  return {
    ...entry,
    menopause_id: entry.menopause_id || entry._id || entry.id || key,
    menopause_date: entry.menopause_date,
    age_first_m: entry.age_first_m || "",
    menstruation: entry.menstruation || "",
    how_long_m_stopped: entry.how_long_m_stopped || "",
    causes_m: entry.causes_m || "",
    other_name: entry.other_name || "",
    how_many_days_occur: entry.how_many_days_occur || "",
    //define for color by id
    created_by: entry.created_by, 
  }
}
